export { default } from "./withSettingsDirectoryPrivileges";
export * from "./withSettingsDirectoryPrivileges";
